/*!
 *
 * app.js
 *
 */
/*** ./modules **/
// import scroll2hash from 'scroll2hash';
import Linker from 'linker';
import smoothScroll from 'smooth-scroll';
import Page2Top from 'page2top';
import Hero from 'hero';
import Slider from 'slider';
import ScrollAnimation from 'scroll-animation';
import * as Fancyapps from "@fancyapps/ui";
var Fancybox = Fancyapps.Fancybox;
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import interview from 'interview';
import index from 'index';
function init() {
    Linker();
    smoothScroll({
        ignore: '[data-ignore-link], .huga a'
    });
    if (document.querySelector('.site-page2top')) {
        Page2Top();
    }
    ;
    Hero();
    Slider();
    if (document.querySelector('.u-sa')) {
        ScrollAnimation();
    }
    ;
    if (document.querySelector('#index')) {
        index();
    }
    ;
    if (document.querySelector('.itv-gallery__item')) {
        Fancybox.bind('.itv-gallery__item', {
            hideScrollbar: false,
            Toolbar: {
                display: {
                    left: [],
                    middle: [],
                    right: ['close'],
                }
            },
            groupAll: true,
            contentClick: false,
            wheel: false,
            Thumbs: false
        });
    }
    if (document.querySelector('#interviewBody')) {
        interview();
    }
    var profile = document.querySelector('.itv-profile__marker');
    if (document.querySelector('.itv-profile__marker')) {
        var profileB = profile.querySelector('b');
        if (profileB.textContent === 'バインデュル　オズヌール') {
            profileB.innerHTML = 'バインデュル<br>オズヌール';
        }
        ;
    }
}
;
// async function initEvents() {
// 	const tabElem = document.querySelector('.top-events__slider');
// 	if (tabElem) {
// 		const { default: TopEvents } = await import(
// 			/* webpackChunkName: "top-events" */ 'top-events'
// 		);
// 		TopEvents('.top-events__slider');
// 	}
// }
// async function initTab() {
// 	const tabElem = document.querySelector('.c-tab');
// 	if (tabElem) {
// 		const { default: Tab } = await import(
// 			/* webpackChunkName: "tab" */ 'tab'
// 		);
// 		Tab('.c-tab')
// 	}
// }
// async function initAccordion() {
// 	const accordionElem = document.querySelector('.p-faq');
// 	if (accordionElem) {
// 		const { default: Accordion } = await import(
// 			/* webpackChunkName: "accordion" */ 'accordion'
// 		);
// 		Accordion('.p-faq', {
// 			containerSelector: '.p-faq__item',
// 			headSelector: '.p-faq__head',
// 			bodySelector: '.p-faq__body'
// 		});
// 	}
// }
document.readyState !== "loading" ? init() : document.addEventListener("DOMContentLoaded", init);
